import { render, staticRenderFns } from "./PakamInfoStep.vue?vue&type=template&id=5ca76fa1&scoped=true"
import script from "./PakamInfoStep.vue?vue&type=script&lang=js"
export * from "./PakamInfoStep.vue?vue&type=script&lang=js"
import style0 from "./PakamInfoStep.vue?vue&type=style&index=0&id=5ca76fa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca76fa1",
  null
  
)

export default component.exports